<template>
  <div class="news-content-container">
    <back-open-chenter />
    <div class="news-content-panel">
      <div class="news-title">腾讯优图斩获首届人工智能安全大赛-深度伪造安全竞赛冠军</div>
      <div class="news-date">2022年9月23日</div>
      <div class="news-content">
        <div>
          <div class="image-panel">
            <img class="news-image" src="../img/detail/Information/news17/news17_17.gif"/>
          </div>
        </div>
        <p>随着深度合成技术的不断发展，Deepfakes等技术可以轻易地对人脸的面部区域进行篡改，并且伪造的人脸越来越逼真，有些甚至达到人眼也难以区分真假的地步。这些技术在娱乐场景得到广泛应用的同时也给社会带来了潜在的风险，例如使用这些技术进行人脸伪造，用于编造虚假新闻、非法身份认证等。</p>
        <p>
          近期，在北京市科委、中关村管委会、北京市经信局的指导下，中关村实验室、国家工信安全中心等单位共同举办了
          <span class="mark-text">首届人工智能安全大赛（AISC 2022）</span>
          。其中
          <span class="mark-text">深度伪造安全竞赛</span>
          重点关注通过分析伪造音视频的相似性，来溯源不同伪造内容是否来自同一种或同一类生物特征生成软件。凭借在人脸安全方面的技术积累和实践经验，
          <span class="mark-text">腾讯优图在该赛道中获得冠军。</span>
        </p>
        <div>
          <div class="image-panel">
            <img class="news-image" src="../img/newscenter/news25.png"/>
          </div>
        </div>
        <div class="news-content-mark">
          <p>● 赛题介绍</p>
        </div>
        <p>本次深度伪造安全竞赛模拟有标签数据和无标签数据结合的深度伪造（下文简称深伪）方法识别场景，关注采用图像检索的方式来解决攻击溯源的问题。通过提交针对深伪方法的识别算法，返回伪造方法相似度高的深伪图片。此外在决赛阶段，还需要实现额外的异常检测功能来检测新型伪造方法。</p>
        <div class="news-content-mark">
          <p>● 方案解析</p>
        </div>
        <p>
          <span class="mark-text">针对初赛的深伪溯源任务，我们提出了一个三阶段的半监督深伪溯源框架：</span>
        </p>
        <p>
          ●
          <span class="mark-text">阶段一：</span>
          针对有标签和无标签的输入，我们通过样本间的特征相似性来促使相同攻击的自动聚类，并利用类别熵最大化法则来加大不同攻击间的差异性。我们还引入了样本不确定性来平衡已知攻击和未知攻击的特征学习。此外，我们还采用了类别平衡采样、BNNeck等技术来进一步提高模型在开放场景下的深伪溯源性能；
        </p>
        <p>
          ●
          <span class="mark-text">阶段二：</span>
          我们利用阶段一训练好的模型提取有标签和无标签数据的特征，随后通过半监督K-Means算法对无标签数据聚类以自适应地分配已知攻击和未知攻击对应的伪标签。我们利用得到的伪标签来优化模型，并反复迭代多次以得到可信度更高的伪标签；
        </p>
        <p>
          ●
          <span class="mark-text">阶段三：</span>
          在阶段二得到的伪标签基础上，我们额外引入了多种学术界攻击数据进行针对性有监督训练，并采用了标签平滑、数据增强和模型融合等策略来进一步增强模型泛化性。
        </p>
        <div>
          <div class="image-panel">
            <img class="news-image" src="../img/detail/news25_1.png"/>
          </div>
        </div>
        <p>
          <span class="mark-text">针对决赛的新型伪造攻击检测任务，我们提出了一个轻量级的多模块异常检测框架。</span>
          我们首先利用预训练好的深伪溯源模型提取查询集和参考集的攻击特征，然后分别通过基于K近邻（KNN）、基于聚类（Cluster）、基于本地离群因子（Local Outlier Factor，LOF）的三个模块进行异常检测，最后综合这三个模块的分数得到最终的新型伪造得分。
        </p>
        <div>
          <div class="image-panel">
            <img class="news-image" src="../img/detail/news25_2.png"/>
          </div>
        </div>
        <div class="news-content-mark">
          <p>● 结语</p>
        </div>
        <p>如今，人脸应用安全是智能时代的重要命题，为防范AI技术滥用，未来，腾讯优图将在人脸安全领域持续深耕，精心打磨算法研究和业务落地，同时开放和输出相关技术服务，更好地保障相关应用的安全，同时坚持科技向善理念，推进可持续社会价值创新，让AI更好地为社会服务。</p>
        <p>
          <a href="https://wj.qq.com/s2/10013969/c79e/" target="_blank" class="mark-text" style="text-decoration: none">了解更多AI信息，联系我们</a>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import BackOpenChenter from '@/components/open/panels/news/detail/BackOpenChenter';
export default {
  name: 'News23',
  components: {
    BackOpenChenter
  }
};
</script>

<style lang="less" scoped>
@import "./news.less";
.news-content {
  margin: 0 auto;
  .image-panel {
    max-width: 667px;
    text-align: center;
    img {
      max-width: 667px;
    }
    span {
      font-size: 12px;
      color: #858585;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/open/panels/news/detail/News25.vue